import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { PortalDeterminationService } from '@core/services/portal-determination.service';
import { ProcessingTypes } from '@core/typings/payment.typing';
import { AddOrgUI } from '@core/typings/ui/add-org.typing';
import { DetailsFormGroup } from '@features/add-organization/add-org-modal/add-org-modal.component';
import { AddOrganizationService } from '@features/add-organization/add-organization.service';
import { TypeSafeFormGroup } from '@yourcause/common/core-forms';
import { FileService, FileTypeService, YcFile } from '@yourcause/common/files';
import { HeapService, TrackingEventNames, TrackingPropertyNames } from '@yourcause/common/heap';
import { Subscription } from 'rxjs';

@Component({
    selector: 'gc-add-org-details',
    templateUrl: './add-org-details.component.html',
    styleUrls: ['./add-org-details.component.scss'],
    standalone: false
})
export class AddOrgDetailsComponent implements OnInit, OnDestroy {
  @Input() detailsFormGroup: TypeSafeFormGroup<DetailsFormGroup>;

  processorType = this.addOrgService.processorType;
  ProcessingTypes = ProcessingTypes;
  acceptedFileTypes = this.fileTypeService.getImageFileTypes();
  captureVetting = false;
  private sub = new Subscription();

  constructor (
    private addOrgService: AddOrganizationService,
    private fileService: FileService,
    private heapService: HeapService,
    private portal: PortalDeterminationService,
    private fileTypeService: FileTypeService
  ) { }

  ngOnInit () {
    this.addOrgService.setValidation(this.detailsFormGroup.valid);
    this.sub.add(this.detailsFormGroup.statusChanges.subscribe(() => {
      this.addOrgService.setValidation(this.detailsFormGroup.valid);
    }));
    this.captureVetting = this.addOrgService.processorType === ProcessingTypes.YourCause;
  }

  updateAddOrg <K extends keyof AddOrgUI.AddOrgPayload> (
    attr: K,
    data: AddOrgUI.AddOrgPayload[K]
  ) {
    this.addOrgService.setAddOrgAttr(attr, data);
  }

  updateVettingContact <K extends keyof AddOrgUI.VettingContactInfo> (
    attr: K,
    data: AddOrgUI.VettingContactInfo[K]
  ) {
    this.addOrgService.setVettingContactInfo(attr, data);
  }


  setImage (images: YcFile[]) {
    if (images.length > 0) {
      // Can only upload 1
      const image = images[0];
      this.addOrgService.setAddOrgAttr('image', image);
      this.fileService.convertFileToB64(image.file)
        .subscribe((base64: string) => {
          this.addOrgService.setAddOrgAttr('imageUrl', base64);
        });
    } else {
      this.addOrgService.setAddOrgAttr('image', null);
      this.addOrgService.setAddOrgAttr('imageUrl', '');
      this.detailsFormGroup.get('image').setValue([]);
    }
  }

  openHelpCenter () {
    const link = this.portal.isManager ? 
      'https://webfiles.blackbaud.com/files/support/helpfiles/grantsconnect/content/gc-applications-vetting-organizations.html' :
      'https://webfiles.blackbaud.com/files/support/helpfiles/grantsconnect/content/gc-applicants-faq-why-is-vetting-required-for-organizations.html';
    this.heapService.track(
      TrackingEventNames.OpenHelp,
      {
        [TrackingPropertyNames.Link]: link
      }
    );
    
    window.open(link, '_blank');
  }


  ngOnDestroy () {
    this.sub.unsubscribe();
  }
}
